import { ProductsList } from "@/@types";
import { ApiClient } from "../../ApiClient";
import { GetProductsListResponse } from "../../products/schema/GetProductsListResponse";
import { mapProducts } from "../../mappers/productsListMapper";

export const getProductsListByBrand = async (brandSlug: string): Promise<ProductsList> => {
    const client = ApiClient.getInstance();

    const response = await client.get<GetProductsListResponse>(`brands/products-by-brand/${brandSlug}`);

    return {
        products: response.data.products.map(mapProducts),
        meta: response.data.meta,
        links: response.data.links,
    }
}